import { Button, Form, Input, Modal } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import axios from "../../utils/axios";

export default function RejectModal({ onCancel, visible, docid }) {
  const { main, mainfilter } = useParams();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationKey: ["reject_sign"],
    mutationFn: (formData) => axios.post("client/api/doc/reject", formData, { showErrorMessage: true, showSuccessMessage: true }),
    onSuccess: ({ success }) => {
      if (success) {
        onCancel();
        queryClient.refetchQueries({ queryKey: ["get_doc_list"] });
        queryClient.refetchQueries({ queryKey: ["get_user_doc_count"] });
        window.location.hash = `/${main}/${mainfilter}/0/0`;
      }
    },
  });

  return (
    <Modal title="Signature rejection confirmation" open={visible} onCancel={onCancel} footer={null}>
      <Form layout="vertical" onFinish={mutate}>
        <Form.Item hidden name="docid" initialValue={docid}>
          <Input />
        </Form.Item>
        <Form.Item name="reason" label="Rejection description" rules={[{ required: true }]}>
          <Input.TextArea style={{ minHeight: "100px" }} placeholder="Type here why you are rejecting this document ... " />
        </Form.Item>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
          <p>Please confirm the rejection</p>
          <Button bg_color="5" className="btnaction_button" loading={isLoading} htmlType="submit">
            Reject signing
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
